import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

var EnhancedModal = function EnhancedModal(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      icon = _ref.icon,
      children = _ref.children,
      buttons = _ref.buttons,
      className = _ref.className,
      portalClassName = _ref.portalClassName,
      modalProps = _objectWithoutProperties(_ref, ["title", "subtitle", "icon", "children", "buttons", "className", "portalClassName"]);

  return /*#__PURE__*/React.createElement(Modal, _extends({
    className: "enhanced-modal ".concat(className || ''),
    portalClassName: "enhanced-modal ".concat(portalClassName || ''),
    size: "lg"
  }, modalProps), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "enhanced-modal__header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "tes-modal__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "enhanced-modal__header-title text-center margin-top"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: "icon icon-xxxxl icon-".concat(icon)
  })), /*#__PURE__*/React.createElement("div", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "enhanced-modal__header-subtitle text-center"
  }, subtitle))), /*#__PURE__*/React.createElement("div", {
    className: "enhanced-modal__body padding-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "enhanced-modal__wrapper padding-md bg-white"
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: "enhanced-modal__buttons"
  }, buttons)));
};

EnhancedModal.displayName = "EnhancedModal";
EnhancedModal.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  buttons: PropTypes.array,
  // eslint-disable-line
  className: PropTypes.string,
  portalClassName: PropTypes.string
};
EnhancedModal.defaultProps = {
  title: null,
  subtitle: null,
  icon: null,
  buttons: [],
  className: null,
  portalClassName: null
};
export default EnhancedModal;